import { PageCreditAccounts } from "@components/modules/credit-account/listing/PageCreditAccounts";
import { NavigationFinance } from "@components/widgets/AppSubNav";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => (
  <MainLayout title={t`Credit accounts`} navigation={<NavigationFinance />}>
    <DemoModule module={Modules.InvoicesCreditAccounts}>
      <PageCreditAccounts />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/invoices/credit-accounts/")({
  component: Page,
});
